/**
 * @module components\ghTable\dataTable\dataRow\dataCell\checkboxCell
 */
import Vue from "vue";
import Component from "vue-class-component";
import DataCellBase from "../dataCellBase";

@Component
export default class CheckboxCell extends DataCellBase {}
